module.exports = __webpack_public_path__ + "static/media/skeleton_circle.7d7ca899.png";